import { posthog } from '@/lib/posthog'

export function useInternalAnalytics() {
  const trackEvent = (
    event: string,
    data: Record<string, unknown> = {},
    entry_id?: number,
    share_id?: number,
    screen_name?: string,
  ) => {
    try {
      const properties: Record<string, unknown> = {
        ...data,
      }

      if (entry_id !== undefined) {
        properties.entry_id = entry_id
      }

      if (share_id !== undefined) {
        properties.share_id = share_id
      }

      if (screen_name !== undefined) {
        properties.screen_name = screen_name
      } else if (typeof window !== 'undefined' && window.location?.pathname) {
        properties.screen_name = window.location.pathname
      }

      posthog.capture(event, properties)
    } catch {
      // Fail silently to prevent telemetry errors from disrupting the UI
    }
  }

  const trackPageView = (
    pageName: string,
    properties: Record<string, unknown> = {},
  ) => {
    trackEvent(
      'page_view',
      { page: pageName, ...properties },
      undefined,
      undefined,
      pageName,
    )
  }

  const trackPaywallView = (
    trigger: string,
    properties: Record<string, unknown> = {},
  ) => {
    trackEvent(
      'paywall_viewed',
      { trigger, ...properties },
      undefined,
      undefined,
      'paywall',
    )
  }

  const trackPricingView = (properties: Record<string, unknown> = {}) => {
    trackEvent('pricing_viewed', properties, undefined, undefined, 'pricing')
  }

  const initHeartbeat = (_customEndpoint?: string) => {
    // Inhouse analytics heartbeats are decommissioned.
    // Return empty cleanup function for caller compatibility.
    return () => {}
  }

  return {
    trackEvent,
    trackPageView,
    trackPaywallView,
    trackPricingView,
    initHeartbeat,
  }
}
